/**
 * Which defenses count as selected: the anchor (the last one clicked, which
 * drives the map fit) plus every id in the multi-selection. Rows, the map
 * layer and the keyboard all ask through here so they agree.
 */
export function isPlanFeatureSelected(
  featureId: string,
  anchorId: string | null,
  multi: readonly string[]
): boolean {
  return featureId === anchorId || multi.includes(featureId);
}

/** The same answer as a Set, for callers that test many ids per change. */
export function planSelectedIdSet(anchorId: string | null, multi: readonly string[]): Set<string> {
  const set = new Set(multi);
  if (anchorId) set.add(anchorId);
  return set;
}

interface ModifierKeys {
  metaKey?: boolean;
  ctrlKey?: boolean;
  shiftKey?: boolean;
}

/** React Native Web hands onPress the DOM click event (modifiers sit on
 *  it, and on its nativeEvent too); a Leaflet click gives the DOM event
 *  directly. Reads either shape. */
function modifiersOf(e: unknown): ModifierKeys {
  if (!e || typeof e !== 'object') return {};
  const ev = e as ModifierKeys & { nativeEvent?: ModifierKeys };
  const native = ev.nativeEvent;
  return {
    metaKey: !!ev.metaKey || !!native?.metaKey,
    ctrlKey: !!ev.ctrlKey || !!native?.ctrlKey,
    shiftKey: !!ev.shiftKey || !!native?.shiftKey,
  };
}

/** Cmd (Mac) or Ctrl (elsewhere) held: toggle one id in the selection. */
export function isToggleClick(e: unknown): boolean {
  const m = modifiersOf(e);
  return !!m.metaKey || !!m.ctrlKey;
}

/** Shift held: select a range. */
export function isRangeClick(e: unknown): boolean {
  return !!modifiersOf(e).shiftKey;
}
